console.log("Search store loaded.");
export default {
  header: "Search",
  view: "Search",
  searches: [],
  domainDetails: null,
  error: null
};
